module.exports = __webpack_public_path__ + "img/category-popular-hover.b814c53a.png";